import * as React from "react";
import { Icon, IconsList } from "./icons";
import * as rootStyles from "../../styles";
import { Card, Row } from "react-bootstrap";

export type InlineToastProps = {
    text: string;
    retryAction?: () => void;
    onDismiss?: () => void;
    sticky?: boolean;
    id: string;
};

export class InlineToast extends React.Component<InlineToastProps> {
    render() {
        let icon;
        let action;
        if (!this.props.sticky) {
            action = this.props.retryAction
                ? this.props.retryAction
                : this.props.onDismiss;
            icon = (
                <Icon
                    size={16}
                    icon={
                        this.props.retryAction
                            ? IconsList.navigation_refresh
                            : IconsList.action_cancelInline
                    }
                    id={`${this.props.id}_Icon`}
                />
            );
        }
        return (
            <Card style={containerStyle} onClick={action}>
                <Row id={this.props.id + "-Text"} style={innerToastStyle}>
                    <span style={textStyle}>{this.props.text}</span>
                    <div style={iconStyle}>{icon}</div>
                </Row>
            </Card>
        );
    }
}

const innerToastStyle: React.CSSProperties = {
    flex: 1,
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "center",
};
const textStyle: React.CSSProperties = {
    flex: 1,
    alignSelf: "center",
    ...rootStyles.textStyles.primary,
};
const iconStyle: React.CSSProperties = {
    alignSelf: "center",
    flex: 0,
};

const containerStyle: React.CSSProperties = {
    backgroundColor: rootStyles.generateColor(
        rootStyles.colors.accent,
        rootStyles.glass._2
    ),
    borderWidth: 1,
    borderColor: rootStyles.colors.accent,
    alignSelf: "stretch",
    flex: 1,
    padding: rootStyles.spacers.medium,
    textAlign: "center",
    margin: rootStyles.spacers.medium,
};
